import { CloseDateType, OpenDateType } from '../AvailabilityConfiguration/types/availability.types'
import { CompletedBookingFirestoreData } from '../../../types/booking.types'
import {
  isSameDayjsTimestamp,
  isSameOrAfterDayjsTimestamp,
  isSameOrBeforeDayjsTimestamp,
  startOfTodayInAppTimezone,
  timestampToDayjs,
} from '../../../utils/dateTime.utils'
import { Dayjs } from 'dayjs'

export const findInvalidFutureConfigurationBookings = (
  bookings: CompletedBookingFirestoreData[],
  openDates: OpenDateType[],
  closeDates: CloseDateType[],
  today: Dayjs = startOfTodayInAppTimezone()
): CompletedBookingFirestoreData[] => {
  return bookings.filter((booking) => {
    const bookingDate = timestampToDayjs(booking.bookingDate)

    if (bookingDate.isBefore(today)) {
      return false
    }

    const isInOpenDateRange = openDates.some(
      (openDate) => isSameOrAfterDayjsTimestamp(bookingDate, openDate.startDate) && isSameOrBeforeDayjsTimestamp(bookingDate, openDate.endDate)
    )
    const isInCloseDates = closeDates.some((closeDate) => isSameDayjsTimestamp(bookingDate, closeDate))

    return isInCloseDates || !isInOpenDateRange
  })
}
